import * as Sentry from "@sentry/react"
const dsn = location.href.match(/localhost/)
  ? ""
  : "https://9b3b3ccb29a54066a2c372e247cdc3ad@o55485.ingest.sentry.io/5388797"
Sentry.init({
  dsn: dsn,
})
export default Sentry
